<div class="card card-body">
  <form
    method="post"
    action="/"
    class="form-horizontal"
    [formGroup]="reportForm"
    autocomplete="off"
  >
    <mat-tab-group style="overflow: none">
      <mat-tab label="General" class="w-100">
        <br />
        <!-- <div class="container-fluid"> -->
        <div class="row">
          <br />
          <div class="col-md-4">
            <div class="form-group">
              <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
              <mat-label>ID</mat-label>
              <mat-form-field appearance="outline" class="w-100">
                <input
                  id="id"
                  matInput
                  type="text"
                  class="form-control"
                  formControlName="id"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-10">
                <div
                  class="form-group"
                  [ngClass]="{
                    'has-danger':
                      reportF['group'].errors &&
                      (reportF['group'].touched || reportF['group'].dirty),
                    'has-success': !reportF['group'].errors
                  }"
                >
                  <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
                  <mat-label>Group*</mat-label>
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-select
                      id="group"
                      matInput
                      class="form-control"
                      ngClass=" btn-round simple"
                      required
                      formControlName="group"
                      [compareWith]="objectComparisonFunction"
                    >
                      @for (group of _groups.groups; track group) {
                      <mat-option [value]="group">
                        {{ group.groupName }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-md-2">
                <button
                  style="position: absolute; bottom: 10px; left: 0px"
                  mat-mini-fab
                  color=""
                  aria-label="Add Group"
                  title="Add Group"
                  (click)="showGroupDialogue()"
                >
                  <mat-icon>add_box</mat-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div
              class="form-group"
              [ngClass]="{
                'has-danger':
                  reportF['reportName'].errors &&
                  (reportF['reportName'].touched ||
                    reportF['reportName'].dirty),
                'has-success': !reportF['reportName'].errors
              }"
            >
              <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
              <mat-label>Report Name*</mat-label>
              <mat-form-field appearance="outline" class="w-100">
                <input
                  id="reportName"
                  matInput
                  type="text"
                  class="form-control"
                  required
                  formControlName="reportName"
                />
                @for (validation of report_validation_messages.reportName; track
                validation) {
                <mat-error>
                  @if (reportForm.get('reportName').hasError(validation.type) &&
                  (reportForm.get('reportName').dirty ||
                  reportForm.get('reportName').touched)) {
                  <mat-error class="error-message">
                    {{ validation.message }}
                  </mat-error>
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-10">
                <div class="form-group">
                  <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
                  <mat-label>Template</mat-label>
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-select
                      id="shortId"
                      matInput
                      class="form-control"
                      ngClass=" btn-round simple"
                      formControlName="shortId"
                    >
                      @for (template of _templates.templates; track template) {
                      <mat-option [value]="template.shortId">
                        {{ template.templateName }}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <br />
              <div class="col-md-2">
                <button
                  style="position: absolute; bottom: 10px; left: 0px"
                  mat-mini-fab
                  color=""
                  aria-label="Add Group"
                  title="Add Template"
                  (click)="showTemplateDialogue()"
                >
                  <mat-icon>add_box</mat-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
              <mat-label>Report Template Name</mat-label>
              <mat-form-field appearance="outline" class="w-100">
                <input
                  id="reportTemplateName"
                  matInput
                  type="text"
                  class="form-control"
                  formControlName="reportTemplateName"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="col-md-4">
            <div
              class="form-group"
              [ngClass]="{
                'has-danger':
                  reportF['reportType'].errors &&
                  (reportF['reportType'].touched ||
                    reportF['reportType'].dirty),
                'has-success': !reportF['reportType'].errors
              }"
            >
              <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
              <mat-label class="mat-form-field-required-marker"
                >Report Type</mat-label
              >
              <mat-form-field appearance="outline" class="w-100">
                <mat-select
                  matInput
                  id="reportType"
                  required
                  class="form-control"
                  ngClass=" btn-round simple"
                  formControlName="reportType"
                >
                  @for (type of mdenumReportType.values(); track type) {
                  <mat-option [value]="mdenumReportType[type]">
                    {{ type }}
                  </mat-option>
                  }
                </mat-select>
                @for (validation of report_validation_messages.reportType; track
                validation) {
                <mat-error>
                  @if (reportForm.get('reportType').hasError(validation.type) &&
                  (reportForm.get('reportType').dirty ||
                  reportForm.get('reportType').touched)) {
                  <mat-error class="error-message">
                    {{ validation.message }}
                  </mat-error>
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
              <mat-label>Permissions</mat-label>
              <mat-form-field appearance="outline" class="w-100">
                <mat-select
                  id="reportPermission"
                  matInput
                  class="form-control"
                  ngClass=" btn-round simple"
                  multiple
                  formControlName="reportPermission"
                >
                  @for (permission of _permissions.permissions; track
                  permission) {
                  <mat-option [value]="permission.name">
                    {{ permission.name }}
                  </mat-option>
                  }
                </mat-select>
                <!--                                <input id="reportPermission" matInput type="text" class="form-control"-->
                <!--                                       formControlName="reportPermission">-->
              </mat-form-field>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
              <mat-label>Description</mat-label>
              <mat-form-field appearance="outline" class="w-100">
                <textarea
                  id="description"
                  matInput
                  type="textarea"
                  style="
                    resize: both;
                    min-height: 2rem;
                    max-height: 20rem;
                    height: 5rem;
                  "
                  class="form-control"
                  formControlName="description"
                ></textarea>
              </mat-form-field>
            </div>
          </div>
          <div class="col-md-2">
            <div
              class="form-group"
              [ngClass]="{
                'has-danger':
                  reportF['reportActive'].errors &&
                  (reportF['reportActive'].touched ||
                    reportF['reportActive'].dirty),
                'has-success': !reportF['reportActive'].errors
              }"
            >
              <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
              <!-- <mat-form-field appearance="outline" class="w-100"> -->
              <mat-checkbox
                color="primary"
                id="reportActive"
                formControlName="reportActive"
              >
                Active
              </mat-checkbox>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
              <!-- <mat-form-field appearance="outline" class="w-100"> -->
              <mat-checkbox
                color="primary"
                id="jobOnServer"
                formControlName="jobOnServer"
              >
                Job Report
              </mat-checkbox>
              <mat-hint
                class="text-sm-left text-info"
                style="display: block; font-size: x-small"
                >Job Report In Background and email Report
              </mat-hint>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
              <!-- <mat-form-field appearance="outline" class="w-100"> -->
              <mat-checkbox
                color="primary"
                id="filterAllowedGIDAccess"
                formControlName="filterAllowedGIDAccess"
              >
                Filter GIDAccess
              </mat-checkbox>
              <mat-hint
                class="text-sm-left text-info"
                style="display: block; font-size: x-small"
              >
                Report is filtered by the GID's that user has access on
              </mat-hint>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <mat-checkbox
                color="primary"
                id="landscape"
                formControlName="landscape"
              >
                Landscape
              </mat-checkbox>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
              <mat-label>Record Date</mat-label>
              <mat-form-field appearance="outline" class="w-100">
                <input
                  id="recordDate"
                  matInput
                  type="text"
                  class="form-control"
                  formControlName="recordDate"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
              <mat-label>Record Time</mat-label>
              <mat-form-field appearance="outline" class="w-100">
                <input
                  id="recordTime"
                  matInput
                  type="text"
                  class="form-control"
                  formControlName="recordTime"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
              <mat-label>User</mat-label>
              <mat-form-field appearance="outline" class="w-100">
                <input
                  id="uacUser"
                  matInput
                  type="text"
                  class="form-control"
                  formControlName="uacUser"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </mat-tab>
      <mat-tab label="SQL">
        <br />
        <!-- <div class="container-md"> -->
        <div class="”row”">
          <div class="col-md-8">
            <div class="form-group">
              <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Enter Report SQL here</mat-label>
                <textarea
                  matInput
                  id="reportSQL"
                  type="textarea"
                  style="
                    resize: both;
                    min-height: 5rem;
                    max-height: 50rem;
                    height: 10rem;
                    min-width: 20rem;
                  "
                  class="form-control resizeable"
                  formControlName="reportSQL"
                ></textarea>
              </mat-form-field>
            </div>
          </div>
          <div class="col-md-4"></div>
        </div>
        <!-- </div> -->
      </mat-tab>
      <mat-tab label="Formatting">
        <br />
        <div class="row w-100">
          <div class="col-md-4">
            <div
              class="form-group"
              [ngClass]="{
                'has-danger':
                  reportF['reportFormatsAllowed'].errors &&
                  (reportF['reportFormatsAllowed'].touched ||
                    reportF['reportFormatsAllowed'].dirty),
                'has-success': !reportF['reportFormatsAllowed'].errors
              }"
            >
              <!-- <label class="col-sm-12 col-form-label" for="ContractReference"
                  >Contract Reference</label
                > -->
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Report Formats Allowed*</mat-label>
                <mat-select
                  id="reportFormatsAllowed"
                  required
                  class="form-control"
                  ngClass=" btn-round simple"
                  formControlName="reportFormatsAllowed"
                  multiple
                >
                  @for (reportFormat of mdenumReportFormat.values(); track
                  reportFormat) {
                  <mat-option [value]="mdenumReportFormat[reportFormat]">
                    {{ reportFormat }}
                  </mat-option>
                  }
                </mat-select>
                @for (validation of
                report_validation_messages.reportFormatsAllowed; track
                validation) {
                <mat-error>
                  @if(reportForm.get('reportFormatsAllowed').hasError(validation.type)
                  && (reportForm.get('reportFormatsAllowed').dirty ||
                  reportForm.get('reportFormatsAllowed').touched)) {
                  <mat-error class="error-message">
                    {{ validation.message }}
                  </mat-error>
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
          <div class="col-md-4">
            <div
              class="form-group"
              [ngClass]="{
                'has-danger':
                  reportF['reportFormatsAllowed'].errors &&
                  (reportF['reportFormatsAllowed'].touched ||
                    reportF['reportFormatsAllowed'].dirty),
                'has-success': !reportF['reportFormatsAllowed'].errors
              }"
            >
              <!-- <label class="col-sm-12 col-form-label" for="ContractReference"
                  >Contract Reference</label
                > -->
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Default Report Format</mat-label>
                <mat-select
                  id="defaultReportFormat"
                  required
                  class="form-control"
                  ngClass=" btn-round simple"
                  formControlName="defaultReportFormat"
                >
                  @for (defaultFormat of
                  this.reportForm.controls['reportFormatsAllowed'].value;; track
                  defaultFormat) {
                  <mat-option [value]="defaultFormat">
                    {{ defaultFormat }}
                  </mat-option>
                  }
                </mat-select>
                @for (validation of
                report_validation_messages.defaultReportFormat; track
                validation) {
                <mat-error>
                  @if(reportForm.get('defaultReportFormat').hasError(validation.type)
                  && (reportForm.get('defaultReportFormat').dirty ||
                  reportForm.get('defaultReportFormat').touched)) {
                  <mat-error class="error-message">
                    {{ validation.message }}
                  </mat-error>
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="Input Fields">
        <br />
        <div class="form-group">
          <div class="py-5 col-sm-4">
            <button
              mat-raised-button
              color="accent"
              type="button"
              class="btn btn-sm btn-primary"
              (click)="addFieldButtonClick()"
            >
              Add Field
            </button>
          </div>
          &nbsp;
        </div>
        <mat-card>
          <mat-card-content>
            <div
              cdkDropList
              class="example-list"
              (cdkDropListDropped)="drop($event)"
            >
              @for (inputField of inputFields.controls; track inputField; let i
              = $index) {
              <div formArrayName="inputFields" cdkDrag>
                <div [formGroupName]="i.toString()">
                  <mat-accordion>
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        @if (inputFields[i]) {
                        <mat-panel-title>
                          <b>{{ _report.inputFields[i].name }}</b>
                        </mat-panel-title>
                        } @if (inputFields[i] === undefined) {
                        <mat-panel-title>
                          <b>{{ inputField.get('name').value }}</b>
                        </mat-panel-title>
                        }
                        <mat-panel-description>
                          Edit Field
                        </mat-panel-description>
                      </mat-expansion-panel-header>
                      <mat-card>
                        <mat-card-header style="padding: 24px">
                          @if (inputFields.length>0) {
                          <div class="col-sm-12">
                            <button
                              mat-raised-button
                              color="warn"
                              class="py-5"
                              aria-label="Delete Field"
                              title="Delete Field"
                              (click)="removeFieldButtonClick(i)"
                            >
                              <!-- <mat-icon>close</mat-icon> -->
                              Delete Field
                            </button>
                          </div>
                          &nbsp; }
                        </mat-card-header>
                        <mat-card-content class="col-md-12">
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
                                <mat-form-field
                                  appearance="outline"
                                  class="w-100"
                                >
                                  <mat-label>Label</mat-label>
                                  <input
                                    [id]="'label' + i"
                                    matInput
                                    type="text"
                                    class="form-control"
                                    formControlName="label"
                                  />
                                  @for (validation of
                                  report_validation_messages.label; track
                                  validation) {
                                  <mat-error>
                                    @if(inputField.get('label').hasError(validation.type)
                                    && (inputField.get('label').dirty ||
                                    inputField.get('label').touched)) {
                                    <mat-error class="error-message">
                                      {{ validation.message }}
                                    </mat-error>
                                    }
                                  </mat-error>
                                  }
                                </mat-form-field>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
                                <mat-form-field
                                  appearance="outline"
                                  class="w-100"
                                >
                                  <mat-label>Name</mat-label>
                                  <input
                                    [id]="'name' + i"
                                    matInput
                                    type="text"
                                    class="form-control"
                                    formControlName="name"
                                  />
                                </mat-form-field>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <mat-tab-group class="col-md-12">
                              <mat-tab [label]="'options'" class="w-100">
                                <!-- <div class="pad-tab-content"> -->
                                <div class="row">
                                  <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                      <mat-label>Type</mat-label>
                                      <mat-select
                                        [id]="'type' + i"
                                        placeholder="Type"
                                        ngClass=" btn-round simple"
                                        required
                                        formControlName="type"
                                      >
                                        <mat-option
                                          *ngFor="let type of controlTypes"
                                          [value]="type"
                                        >
                                          {{ type }}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                  </div>

                                  <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                      <mat-label>Input Type</mat-label>
                                      <mat-select
                                        [id]="'inputType' + i"
                                        placeholder="Input Type"
                                        ngClass=" btn-round simple"
                                        formControlName="inputType"
                                      >
                                        <mat-option
                                          *ngFor="let type of inputTypes"
                                          [value]="type"
                                        >
                                          {{ type }}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-4">
                                    <mat-checkbox
                                      [id]="'multipleSelect' + i"
                                      formControlName="multipleSelect"
                                    >
                                      Multiple Select
                                    </mat-checkbox>
                                  </div>

                                  <div class="col-md-4">
                                    <mat-checkbox
                                      [id]="'required' + i"
                                      formControlName="required"
                                      >Required
                                    </mat-checkbox>
                                  </div>

                                  <div class="col-md-4">
                                    <mat-checkbox
                                      [id]="'ignoreOnFilter' + i"
                                      formControlName="ignoreOnFilter"
                                    >
                                      ignore On Filter
                                    </mat-checkbox>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-8">
                                    <mat-form-field class="w-100">
                                      <mat-label>Options</mat-label>
                                      <input
                                        [id]="'options' + i"
                                        matInput
                                        type="text"
                                        placeholder="Options"
                                        formControlName="options"
                                      />
                                    </mat-form-field>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-8">
                                    <mat-form-field class="w-100">
                                      <mat-label>Option Values</mat-label>
                                      <input
                                        [id]="'optionValues' + i"
                                        matInput
                                        type="text"
                                        placeholder="Option Values"
                                        formControlName="optionValues"
                                      />
                                    </mat-form-field>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                      <mat-label>Value</mat-label>
                                      <input
                                        [id]="'value' + i"
                                        matInput
                                        type="text"
                                        placeholder="Value"
                                        formControlName="value"
                                      />
                                    </mat-form-field>
                                  </div>
                                </div>

                                <!-- </div> -->
                              </mat-tab>
                              <mat-tab [label]="'options2'" class="w-100">
                                <!-- <div class="pad-tab-content"> -->
                                <button
                                  type="button"
                                  mat-stroked-button
                                  (click)="addToggleFieldButtonClick(i)"
                                >
                                  Add Toggle Field
                                </button>

                                <div
                                  formArrayName="toggleFields"
                                  *ngFor="
                                    let toggleField of getCurrentToggleFieldsGroup(
                                      i
                                    )?.controls;
                                    let j = index
                                  "
                                >
                                  <div [formGroupName]="j.toString()">
                                    <mat-divider
                                      style="margin-bottom: 30px"
                                      class="bg-brand-info"
                                      *ngIf="j > 0"
                                    >
                                    </mat-divider>

                                    <button
                                      mat-mini-fab
                                      color="warn"
                                      class="pull-right"
                                      aria-label="Delete Field"
                                      title="Delete Field"
                                      (click)="
                                        removeToggleFieldButtonClick(i, j)
                                      "
                                    >
                                      <mat-icon>close</mat-icon>
                                    </button>

                                    <div class="row">
                                      <div class="p-10">
                                        <mat-form-field>
                                          <mat-label>Field Name</mat-label>
                                          <input
                                            [id]="'fieldName' + j"
                                            matInput
                                            type="text"
                                            placeholder="Field Name"
                                            formControlName="fieldName"
                                          />
                                          <div
                                            *ngFor="
                                              let validation of report_validation_messages.fieldName
                                            "
                                          >
                                            <mat-error
                                              class="error-message"
                                              *ngIf="
                                                toggleField
                                                  .get('fieldName')
                                                  ?.hasError(validation.type) &&
                                                (toggleField.get('fieldName')
                                                  ?.dirty ||
                                                  toggleField.get('fieldName')
                                                    ?.touched)
                                              "
                                            >
                                              {{ validation.message }}
                                            </mat-error>
                                          </div>
                                        </mat-form-field>
                                      </div>

                                      <div class="p-10">
                                        <mat-form-field>
                                          <mat-label>Values</mat-label>
                                          <input
                                            [id]="'values' + j"
                                            matInput
                                            type="text"
                                            placeholder="Values"
                                            formControlName="values"
                                          />
                                        </mat-form-field>
                                      </div>

                                      <div class="p-10">
                                        <mat-checkbox
                                          [id]="'show' + j"
                                          formControlName="show"
                                          (change)="
                                            toggleShowHide($event, i, j)
                                          "
                                          >show
                                        </mat-checkbox>
                                      </div>

                                      <div class="p-10">
                                        <mat-checkbox
                                          [id]="'hide' + j"
                                          formControlName="hide"
                                          (change)="
                                            toggleShowHide($event, i, j)
                                          "
                                          >hide
                                        </mat-checkbox>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <!-- </div> -->
                              </mat-tab>
                            </mat-tab-group>
                          </div>
                        </mat-card-content>
                      </mat-card>

                      <!-- <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-pills nav-pills-success justify-content-start tab-space"> -->
                      <!-- <li [ngbNavItem]="1">
                      <a ngbNavLink>Options</a>
                      <ng-template ngbNavContent style="margin: 10px">
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group"> -->
                      <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
                      <!--                                          <mat-form-field class="w-100"appearance="outline" class="example-full-width">-->
                      <!-- <label>Type</label>
                            <mat-select [id]="'type'+i"
                              ngClass=" btn-round simple"
                              required class="form-control"
                              formControlName="type">
                              @for (type of controlTypes; track type) {
                                <mat-option
                                  [value]="type">
                                  {{ type }}
                                </mat-option>
                              }
                            </mat-select> -->
                      <!--                                          </mat-form-field>-->
                      <!-- </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group"> -->
                      <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
                      <!-- <label>Input Type</label> -->
                      <!--                                          <mat-form-field appearance="outline" class="example-full-width">-->
                      <!-- <mat-select [id]="'inputType'+i"
                          ngClass=" btn-round simple"
                          class="form-control"
                          formControlName="inputType">
                          @for (type of inputTypes; track type) {
                            <mat-option
                              [value]="type">
                              {{ type }}
                            </mat-option>
                          }
                        </mat-select> -->
                      <!--                                          </mat-form-field>-->
                      <!-- </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group"> -->
                      <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
                      <!-- <label>Options</label> -->
                      <!--                                          <mat-form-field appearance="outline" class="example-full-width">-->
                      <!-- <input [id]="'options'+i" matInput
                      type="text" class="form-control"
                      formControlName="options"> -->
                      <!--                                          </mat-form-field>-->
                      <!-- </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group"> -->
                      <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
                      <!--                                <mat-form-field appearance="outline" class="example-full-width">-->
                      <!-- <mat-checkbox [id]="'multipleSelect'+i"
                    class="form-check-input"
                    formControlName="multipleSelect">
                    Multiple Select
                  </mat-checkbox> -->
                      <!--                                </mat-form-field>-->
                      <!-- </div>
            </div>
            <div class="col-md-2">
              <div class="form-group"> -->
                      <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
                      <!--                                <mat-form-field appearance="outline" class="example-full-width">-->
                      <!-- <mat-checkbox [id]="'required'+i"
                class="form-check-input"
                formControlName="required">
                Required
              </mat-checkbox> -->
                      <!--                                </mat-form-field>-->
                      <!-- </div>
        </div>
        <div class="col-md-2">
          <div class="form-group"> -->
                      <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
                      <!--                                <mat-form-field appearance="outline" class="example-full-width">-->
                      <!-- <mat-checkbox [id]="'ignoreOnFilter'+i"
            class="form-check-input"
            formControlName="ignoreOnFilter">
            ignore On Filter
          </mat-checkbox> -->
                      <!--                                </mat-form-field>-->
                      <!-- </div>
    </div>
    <div class="col-md-4">
      <div class="form-group"> -->
                      <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
                      <!-- <label>Option Values</label> -->
                      <!--                                          <mat-form-field appearance="outline" class="example-full-width">-->
                      <!-- <input [id]="'optionValues'+i" matInput
        type="text" class="form-control"
        formControlName="optionValues"> -->
                      <!--                                          </mat-form-field>-->
                      <!-- </div>
  </div>
  <div class="col-md-4">
    <div class="form-group"> -->
                      <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
                      <!-- <label>Value</label> -->
                      <!--                                          <mat-form-field appearance="outline" class="example-full-width">-->
                      <!-- <input [id]="'value'+i" matInput type="text"
      class="form-control"
      formControlName="value"> -->
                      <!--                                          </mat-form-field>-->
                      <!-- </div>
</div>
<div class="col-md-4">
  <div class="form-group"> -->
                      <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
                      <!--                                      <mat-form-field appearance="outline" class="example-full-width">-->
                      <!-- <label>Collections</label>
  <input [id]="'collections'+i" matInput
    type="text" class="form-control"
    formControlName="collections"> -->
                      <!--                                      </mat-form-field>-->
                      <!-- </div>
</div>
</div>
</ng-template>
</li> -->
                      <!-- <li [ngbNavItem]="2">
  <a ngbNavLink>More Options</a>
  <ng-template ngbNavContent style="margin: 10px">
    <div class="container">
      <div class="row" style="display:block;">
        <div class="col col-12">
          <div class="form-group">
            <button type="button"
              class="btn btn-sm btn-primary"
              (click)="addToggleFieldButtonClick(i)">
              Add Toggle Field
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        @for (toggleField of getCurrentToggleFieldsGroup(i)?.controls; track toggleField; let j = $index) {
          <div formArrayName="toggleFields"
            >
            <div [formGroupName]="j.toString()">
              @if (j>0) {
                <mat-divider style="margin-bottom: 30px"
                  class="bg-brand-info"
                ></mat-divider>
              }
              @if (getCurrentToggleFieldsGroup(i)?.length>0) {
                <div class="col-sm-12"
                  >
                  <button mat-mini-fab color="warn"
                    class="pull-right"
                    aria-label="Delete Field"
                    title="Delete Field"
                    (click)="removeToggleFieldButtonClick(i,j)">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              }
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group"> -->
                      <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
                      <!-- <mat-form-field appearance="outline"
                    class="example-full-width">
                    <input [id]="'fieldName'+j"
                      matInput
                      type="text"
                      placeholder="Field Name"
                      formControlName="fieldName">
                      @for (validation of report_validation_messages.fieldName; track validation) {
                        <mat-error
                          >
                          @if (toggleField.get('fieldName').hasError(validation.type) && (toggleField.get('fieldName').dirty || toggleField.get('fieldName').touched)) {
                            <mat-error
                              class="error-message"
                              >
                              {{validation.message}}
                            </mat-error>
                          }
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group"> -->
                      <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
                      <!-- <mat-form-field appearance="outline"
                    class="example-full-width">
                    <input [id]="'values'+j"
                      matInput
                      type="text"
                      placeholder="Values"
                      formControlName="values">
                      <span class="form-control-feedback">
                        <i class="material-icons">done</i>
                      </span>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <div class="form-check">
                      <label class="col-form-label">
                        <input type="checkbox"
                          [id]="'show'+j"
                          class="example-margin"
                          formControlName="show"
                          (change)="toggleShowHide($event,i,j)">
                          show
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <div class="form-check">
                        <label class="col-form-label">
                          <input type="checkbox"
                            [id]="'hide'+j"
                            class="example-margin"
                            formControlName="hide"
                            (change)="toggleShowHide($event,i,j)">
                            hide
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </ng-template>
    </li> -->
                      <!-- </ul> -->
                      <!-- <div [ngbNavOutlet]="nav" class="mt-2"></div> -->
                      <!--                                                    <ngb-tabset-->
                      <!--                                                            type="pills"-->
                      <!--                                                            class="nav nav-pills nav-pills-primary justify-content-start tab-space"-->
                      <!--                                                    >-->
                      <!--                                                        <ngb-tab title="Options">-->
                      <!--                                                            <ng-template ngbTabContent>-->
                      <!--                                                                &lt;!&ndash;                                      <div class="tab-pane active" [id]="'options'+i">&ndash;&gt;-->
                      <!--                                                                <div class="row">-->
                      <!--                                                                    <div class="col-md-4">-->
                      <!--                                                                        <div class="form-group">-->
                      <!--                                                                            &lt;!&ndash;<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>&ndash;&gt;-->
                      <!--                                                                            &lt;!&ndash;                                          <mat-form-field appearance="outline" class="example-full-width">&ndash;&gt;-->
                      <!--                                                                            <label>Type</label>-->
                      <!--                                                                            <mat-select [id]="'type'+i"-->
                      <!--                                                                                        ngClass=" btn-round simple"-->
                      <!--                                                                                        required class="form-control"-->
                      <!--                                                                                        formControlName="type">-->
                      <!--                                                                                <mat-option-->
                      <!--                                                                                        *ngFor="let type of controlTypes;"-->
                      <!--                                                                                        [value]="type">-->
                      <!--                                                                                    {{ type }}-->
                      <!--                                                                                </mat-option>-->
                      <!--                                                                            </mat-select>-->
                      <!--                                                                            &lt;!&ndash;                                          </mat-form-field>&ndash;&gt;-->
                      <!--                                                                        </div>-->
                      <!--                                                                    </div>-->
                      <!--                                                                    <div class="col-md-4">-->
                      <!--                                                                        <div class="form-group">-->
                      <!--                                                                            &lt;!&ndash;<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>&ndash;&gt;-->
                      <!--                                                                            <label>Input Type</label>-->
                      <!--                                                                            &lt;!&ndash;                                          <mat-form-field appearance="outline" class="example-full-width">&ndash;&gt;-->
                      <!--                                                                            <mat-select [id]="'inputType'+i"-->
                      <!--                                                                                        ngClass=" btn-round simple"-->
                      <!--                                                                                        class="form-control"-->
                      <!--                                                                                        formControlName="inputType">-->
                      <!--                                                                                <mat-option-->
                      <!--                                                                                        *ngFor="let type of inputTypes;"-->
                      <!--                                                                                        [value]="type">-->
                      <!--                                                                                    {{ type }}-->
                      <!--                                                                                </mat-option>-->
                      <!--                                                                            </mat-select>-->
                      <!--                                                                            &lt;!&ndash;                                          </mat-form-field>&ndash;&gt;-->
                      <!--                                                                        </div>-->
                      <!--                                                                    </div>-->
                      <!--                                                                    <div class="col-md-4">-->
                      <!--                                                                        <div class="form-group">-->
                      <!--                                                                            &lt;!&ndash;<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>&ndash;&gt;-->
                      <!--                                                                            <label>Options</label>-->
                      <!--                                                                            &lt;!&ndash;                                          <mat-form-field appearance="outline" class="example-full-width">&ndash;&gt;-->
                      <!--                                                                            <input [id]="'options'+i" matInput-->
                      <!--                                                                                   type="text" class="form-control"-->
                      <!--                                                                                   formControlName="options">-->
                      <!--                                                                            &lt;!&ndash;                                          </mat-form-field>&ndash;&gt;-->
                      <!--                                                                        </div>-->
                      <!--                                                                    </div>-->
                      <!--                                                                    <div class="col-md-2">-->
                      <!--                                                                        <div class="form-group">-->
                      <!--                                                                            &lt;!&ndash;<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>&ndash;&gt;-->
                      <!--                                                                            &lt;!&ndash;                                <mat-form-field appearance="outline" class="example-full-width">&ndash;&gt;-->
                      <!--                                                                            <mat-checkbox [id]="'multipleSelect'+i"-->
                      <!--                                                                                          class="form-check-input"-->
                      <!--                                                                                          formControlName="multipleSelect">-->
                      <!--                                                                                Multiple Select-->
                      <!--                                                                            </mat-checkbox>-->
                      <!--                                                                            &lt;!&ndash;                                </mat-form-field>&ndash;&gt;-->
                      <!--                                                                        </div>-->
                      <!--                                                                    </div>-->
                      <!--                                                                    <div class="col-md-2">-->
                      <!--                                                                        <div class="form-group">-->
                      <!--                                                                            &lt;!&ndash;<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>&ndash;&gt;-->
                      <!--                                                                            &lt;!&ndash;                                <mat-form-field appearance="outline" class="example-full-width">&ndash;&gt;-->
                      <!--                                                                            <mat-checkbox [id]="'required'+i"-->
                      <!--                                                                                          class="form-check-input"-->
                      <!--                                                                                          formControlName="required">-->
                      <!--                                                                                Required-->
                      <!--                                                                            </mat-checkbox>-->
                      <!--                                                                            &lt;!&ndash;                                </mat-form-field>&ndash;&gt;-->
                      <!--                                                                        </div>-->
                      <!--                                                                    </div>-->
                      <!--                                                                    <div class="col-md-2">-->
                      <!--                                                                        <div class="form-group">-->
                      <!--                                                                            &lt;!&ndash;<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>&ndash;&gt;-->
                      <!--                                                                            &lt;!&ndash;                                <mat-form-field appearance="outline" class="example-full-width">&ndash;&gt;-->
                      <!--                                                                            <mat-checkbox [id]="'ignoreOnFilter'+i"-->
                      <!--                                                                                          class="form-check-input"-->
                      <!--                                                                                          formControlName="ignoreOnFilter">-->
                      <!--                                                                                ignore On Filter-->
                      <!--                                                                            </mat-checkbox>-->
                      <!--                                                                            &lt;!&ndash;                                </mat-form-field>&ndash;&gt;-->
                      <!--                                                                        </div>-->
                      <!--                                                                    </div>-->
                      <!--                                                                    <div class="col-md-4">-->
                      <!--                                                                        <div class="form-group">-->
                      <!--                                                                            &lt;!&ndash;<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>&ndash;&gt;-->
                      <!--                                                                            <label>Option Values</label>-->
                      <!--                                                                            &lt;!&ndash;                                          <mat-form-field appearance="outline" class="example-full-width">&ndash;&gt;-->
                      <!--                                                                            <input [id]="'optionValues'+i" matInput-->
                      <!--                                                                                   type="text" class="form-control"-->
                      <!--                                                                                   formControlName="optionValues">-->
                      <!--                                                                            &lt;!&ndash;                                          </mat-form-field>&ndash;&gt;-->
                      <!--                                                                        </div>-->
                      <!--                                                                    </div>-->
                      <!--                                                                    <div class="col-md-4">-->
                      <!--                                                                        <div class="form-group">-->
                      <!--                                                                            &lt;!&ndash;<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>&ndash;&gt;-->
                      <!--                                                                            <label>Value</label>-->
                      <!--                                                                            &lt;!&ndash;                                          <mat-form-field appearance="outline" class="example-full-width">&ndash;&gt;-->
                      <!--                                                                            <input [id]="'value'+i" matInput type="text"-->
                      <!--                                                                                   class="form-control"-->
                      <!--                                                                                   formControlName="value">-->
                      <!--                                                                            &lt;!&ndash;                                          </mat-form-field>&ndash;&gt;-->
                      <!--                                                                        </div>-->
                      <!--                                                                    </div>-->
                      <!--                                                                    <div class="col-md-4">-->
                      <!--                                                                        <div class="form-group">-->
                      <!--                                                                            &lt;!&ndash;<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>&ndash;&gt;-->
                      <!--                                                                            &lt;!&ndash;                                      <mat-form-field appearance="outline" class="example-full-width">&ndash;&gt;-->
                      <!--                                                                            <label>Collections</label>-->
                      <!--                                                                            <input [id]="'collections'+i" matInput-->
                      <!--                                                                                   type="text" class="form-control"-->
                      <!--                                                                                   formControlName="collections">-->
                      <!--                                                                            &lt;!&ndash;                                      </mat-form-field>&ndash;&gt;-->
                      <!--                                                                        </div>-->
                      <!--                                                                    </div>-->
                      <!--                                                                </div>-->
                      <!--                                                                &lt;!&ndash;                                      </div>&ndash;&gt;-->
                      <!--                                                            </ng-template>-->
                      <!--                                                        </ngb-tab>-->
                      <!--                                                        <ngb-tab title="More Options">-->
                      <!--                                                            <ng-template ngbTabContent>-->
                      <!--                                                                <div class="container">-->
                      <!--                                                                    <div class="row" style="display:block;">-->
                      <!--                                                                        <div class="col col-12">-->
                      <!--                                                                            <div class="form-group">-->
                      <!--                                                                                <button type="button"-->
                      <!--                                                                                        class="btn btn-sm btn-primary"-->
                      <!--                                                                                        (click)="addToggleFieldButtonClick(i)">-->
                      <!--                                                                                    Add Toggle Field-->
                      <!--                                                                                </button>-->
                      <!--                                                                            </div>-->
                      <!--                                                                        </div>-->
                      <!--                                                                    </div>-->
                      <!--                                                                    <div class="row">-->
                      <!--                                                                        <div formArrayName="toggleFields"-->
                      <!--                                                                             *ngFor="let toggleField of getCurrentToggleFieldsGroup(i)?.controls; let j = index;">-->
                      <!--                                                                            <div [formGroupName]="j.toString()">-->
                      <!--                                                                                <mat-divider style="margin-bottom: 30px"-->
                      <!--                                                                                             class="bg-brand-info"-->
                      <!--                                                                                             *ngIf="j>0"></mat-divider>-->
                      <!--                                                                                <div class="col-sm-12"-->
                      <!--                                                                                     *ngIf="getCurrentToggleFieldsGroup(i)?.length>0">-->
                      <!--                                                                                    <button mat-mini-fab color="warn"-->
                      <!--                                                                                            class="pull-right"-->
                      <!--                                                                                            aria-label="Delete Field"-->
                      <!--                                                                                            title="Delete Field"-->
                      <!--                                                                                            (click)="removeToggleFieldButtonClick(i,j)">-->
                      <!--                                                                                        <mat-icon>close</mat-icon>-->
                      <!--                                                                                    </button>-->
                      <!--                                                                                </div>-->
                      <!--                                                                                <div class="row">-->
                      <!--                                                                                    <div class="col-md-6">-->
                      <!--                                                                                        <div class="form-group">-->
                      <!--                                                                                            &lt;!&ndash;<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>&ndash;&gt;-->
                      <!--                                                                                            <mat-form-field appearance="outline"-->
                      <!--                                                                                                    class="example-full-width">-->
                      <!--                                                                                                <input [id]="'fieldName'+j"-->
                      <!--                                                                                                       matInput-->
                      <!--                                                                                                       type="text"-->
                      <!--                                                                                                       placeholder="Field Name"-->
                      <!--                                                                                                       formControlName="fieldName">-->
                      <!--                                                                                                <mat-error-->
                      <!--                                                                                                        *ngFor="let validation of report_validation_messages.fieldName">-->
                      <!--                                                                                                    <mat-error-->
                      <!--                                                                                                            class="error-message"-->
                      <!--                                                                                                            *ngIf="toggleField.get('fieldName').hasError(validation.type) && (toggleField.get('fieldName').dirty || toggleField.get('fieldName').touched)">-->
                      <!--                                                                                                        {{validation.message}}-->
                      <!--                                                                                                    </mat-error>-->
                      <!--                                                                                                </mat-error>-->
                      <!--                                                                                            </mat-form-field>-->
                      <!--                                                                                        </div>-->
                      <!--                                                                                    </div>-->
                      <!--                                                                                    <div class="col-md-6">-->
                      <!--                                                                                        <div class="form-group">-->
                      <!--                                                                                            &lt;!&ndash;<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>&ndash;&gt;-->
                      <!--                                                                                            <mat-form-field appearance="outline"-->
                      <!--                                                                                                    class="example-full-width">-->
                      <!--                                                                                                <input [id]="'values'+j"-->
                      <!--                                                                                                       matInput-->
                      <!--                                                                                                       type="text"-->
                      <!--                                                                                                       placeholder="Values"-->
                      <!--                                                                                                       formControlName="values">-->
                      <!--                                                                                                <span class="form-control-feedback">-->
                      <!--                                        <i class="material-icons">done</i>-->
                      <!--                                      </span>-->
                      <!--                                                                                            </mat-form-field>-->
                      <!--                                                                                        </div>-->
                      <!--                                                                                    </div>-->
                      <!--                                                                                    <div class="col-md-6">-->
                      <!--                                                                                        <div class="form-group">-->
                      <!--                                                                                            <div class="form-check">-->
                      <!--                                                                                                <label class="col-form-label">-->
                      <!--                                                                                                    <input type="checkbox"-->
                      <!--                                                                                                           [id]="'show'+j"-->
                      <!--                                                                                                           class="example-margin"-->
                      <!--                                                                                                           formControlName="show"-->
                      <!--                                                                                                           (change)="toggleShowHide($event,i,j)">-->
                      <!--                                                                                                    show-->
                      <!--                                                                                                </label>-->
                      <!--                                                                                            </div>-->
                      <!--                                                                                        </div>-->
                      <!--                                                                                    </div>-->
                      <!--                                                                                    <div class="col-md-6">-->
                      <!--                                                                                        <div class="form-group">-->
                      <!--                                                                                            <div class="form-check">-->
                      <!--                                                                                                <label class="col-form-label">-->
                      <!--                                                                                                    <input type="checkbox"-->
                      <!--                                                                                                           [id]="'hide'+j"-->
                      <!--                                                                                                           class="example-margin"-->
                      <!--                                                                                                           formControlName="hide"-->
                      <!--                                                                                                           (change)="toggleShowHide($event,i,j)">-->
                      <!--                                                                                                    hide-->
                      <!--                                                                                                </label>-->
                      <!--                                                                                            </div>-->
                      <!--                                                                                        </div>-->
                      <!--                                                                                    </div>-->
                      <!--                                                                                </div>-->
                      <!--                                                                            </div>-->
                      <!--                                                                        </div>-->
                      <!--                                                                    </div>-->
                      <!--                                                                </div>-->
                      <!--                                                            </ng-template>-->
                      <!--                                                        </ngb-tab>-->
                      <!--                                                    </ngb-tabset>-->
                      <!--                                <div class="tab-content">-->
                      <!--                                  -->
                      <!--                                  <div class="tab-pane" [id]="'options2'+i">-->
                      <!--                                    -->
                      <!--                                  </div>-->
                      <!--                                </div>-->
                    </mat-expansion-panel>
                  </mat-accordion>
                  <mat-divider
                    style="margin-bottom: 30px"
                    class="bg-brand-info"
                  ></mat-divider>
                </div>
              </div>
              }
            </div>
          </mat-card-content>
        </mat-card>
      </mat-tab>
      <mat-tab label="Summary Fields">
        <br />
        <div class="form-group">
          <div class="col-sm-offset-2 col-sm-4">
            <button
              mat-raised-button
              color="accent"
              type="button"
              class="py-5"
              (click)="addSummaryButtonClick()"
            >
              Add Summary Field
            </button>
          </div>
          &nbsp;
        </div>
        <div
          class="card bg"
          style="border: #616161; border-style: solid; border-width: thin"
        >
          <div class="card-body">
            <div
              cdkDropList
              class="example-list"
              (cdkDropListDropped)="dropSummary($event)"
            >
              @for (summaryField of summaryFields?.controls; track summaryField;
              let i = $index) {
              <div formArrayName="summaryFields" cdkDrag>
                <div [formGroupName]="i.toString()">
                  <mat-accordion>
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        @if (summaryFields[i]) {
                        <mat-panel-title>
                          <b>{{ _report.summaryFields[i].summaryFieldName }}</b>
                        </mat-panel-title>
                        } @if (summaryFields[i] === undefined) {
                        <mat-panel-title>
                          <b>{{
                            summaryField.get('summaryFieldName').value
                          }}</b>
                        </mat-panel-title>
                        }
                        <mat-panel-description>
                          Edit Field
                        </mat-panel-description>
                      </mat-expansion-panel-header>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-4">
                            <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
                            <mat-form-field appearance="outline" class="w-100">
                              <input
                                [id]="'summaryFieldName' + i"
                                matInput
                                type="text"
                                placeholder="Summary Field Name"
                                formControlName="summaryFieldName"
                              />
                              @for (validation of
                              report_validation_messages.summaryFieldName; track
                              validation) {
                              <mat-error>
                                @if(summaryField.get('summaryFieldName').hasError(validation.type)
                                && (summaryField.get('summaryFieldName').dirty
                                ||
                                summaryField.get('summaryFieldName').touched)) {
                                <mat-error class="error-message">
                                  {{ validation.message }}
                                </mat-error>
                                }
                              </mat-error>
                              }
                            </mat-form-field>
                          </div>
                          <div class="col-md-4">
                            <!--<label class="col-sm-12 col-form-label" for="ContractReference">Contract Reference</label>-->
                            <mat-form-field appearance="outline" class="w-100">
                              <input
                                [id]="'displayName' + i"
                                matInput
                                type="text"
                                placeholder="Display Name"
                                formControlName="displayName"
                              />
                              @for (validation of
                              report_validation_messages.displayName; track
                              validation) {
                              <mat-error>
                                @if(summaryField.get('displayName').hasError(validation.type)
                                && (summaryField.get('displayName').dirty ||
                                summaryField.get('displayName').touched)) {
                                <mat-error class="error-message">
                                  {{ validation.message }}
                                </mat-error>
                                }
                              </mat-error>
                              }
                            </mat-form-field>
                          </div>
                          <div class="col-md-4">
                            <mat-form-field appearance="outline" class="w-100">
                              <mat-select
                                matInput
                                [id]="'summaryType' + i"
                                placeholder="Summary Type"
                                ngClass=" btn-round simple"
                                required
                                formControlName="summaryType"
                              >
                                @for (type of mdenumsummaryTypes.values(); track
                                type) {
                                <mat-option [value]="mdenumsummaryTypes[type]">
                                  {{ type }}
                                </mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div class="col-md-4">
                            @if (summaryFields.length>0) {
                            <div>
                              <button
                                color="warn"
                                mat-flat-button
                                class="btn btn-sm btn-danger pull-right"
                                aria-label="Delete Field"
                                title="Delete Field"
                                (click)="removeSummaryButtonClick(i)"
                              >
                                Delete
                                <!--                              <mat-icon>close</mat-icon>-->
                              </button>
                            </div>
                            }
                          </div>
                        </div>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                  <mat-divider
                    style="margin-bottom: 30px"
                    class="bg-brand-info"
                  ></mat-divider>
                </div>
              </div>
              }
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Schedule">
        <br />
        <div class="container-fluid">
          <auth-suite-report-schedule-table
            [report]="_report"
          ></auth-suite-report-schedule-table>
        </div>
      </mat-tab>
      <mat-tab label="History">
        <br />
        <div class="container-fluid">
          <auth-suite-softsplice-co-za-report-history-table
            [report]="_report"
          ></auth-suite-softsplice-co-za-report-history-table>
        </div>
      </mat-tab>
    </mat-tab-group>
    <div class="row">
      <div class="col-sm-10">
        <button
          mat-flat-button
          color="primary"
          class="btn btn-success btn-sm"
          style="margin: 5px"
          (click)="submit()"
          [disabled]="_saveBtnstate || reportForm.invalid"
        >
          Save Report
        </button>
        <button
          mat-flat-button
          color="accent"
          class="btn btn-info btn-sm"
          type="button"
          style="margin: 5px"
          (click)="resetForm()"
        >
          Reset
        </button>
        <!--          <button mat-raised-button class="btn btn-primary btn-sm" -->
        <!--                  (click)="showSwal('warning-message-and-confirmation')" -->
        <!--                  [disabled]="cancelBtnstate" *ngIf="auth.isAuthenticated$ && auth.userHasScopes(['cancel:mdb'])">-->
        <!--            Cancel Mandate-->
        <!--          </button>-->
        @if (_report) {
        <button
          mat-flat-button
          color="warn"
          class="btn btn-danger btn-sm"
          style="margin: 5px"
          (click)="showSwal('warning-message-and-confirmation')"
        >
          Delete Report
        </button>
        }
      </div>
      <div class="col-sm-auto">
        <button
          mat-flat-button
          color="primary"
          class="btn btn-warning btn-sm"
          type="button"
          style="margin: 5px"
          (click)="closeForm()"
        >
          Close
        </button>
      </div>
    </div>
    @if (reportForm.invalid) {
    <div class="row text-danger">Complete all Required fields</div>
    } @if (_showMsg) {
    <div class="alert alert-success fade show" role="alert" color="success">
      <button
        mat-mini-fab
        color="accent"
        type="button"
        class="close"
        data-dismiss="alert"
      >
        &times;
      </button>
      {{ _message }}
    </div>
    }
  </form>
  <!--    activeIds="ngb-panel-0"-->
  <!-- <ngb-accordion
  #acc="ngbAccordion"
  class="card-collapse inner-cards-plain"
  >
  <ngb-panel>
    <ng-template ngbPanelTitle>
      <a class="collapsed">
        Form Information
        <i class="now-ui-icons arrows-1_minimal-down"></i>
      </a>
    </ng-template>
    <ng-template ngbPanelContent>
      <div class="card-body">
        <div class="alert-primary">
          <table class="table-bordered">
            <tr>
              <th>Description</th>
              <th>Value</th>
            </tr>
            <tr>
              <td>Response</td>
              <td> -->
  <!--                    <div class="text_bold text-dark">{{ createResponse | json }}</div>-->
  <!-- </td>
          </tr>
          <tr>
            <td>Form Values</td>
            <td>
              <div class="text_bold text-dark">{{ reportForm.value | json }}</div>
            </td>
          </tr>
          <tr>
            <td>Form State</td>
            <td>
              <div class="text_bold text-dark">
                Form Touched: {{ reportForm.touched | json }}
                <br/>
                Form Pristine: {{ reportForm.pristine | json }}
                <br/>
                Form Valid: {{ reportForm.valid | json }}
                <br/>
                SaveBtn State: {{_saveBtnstate}}
                <br/>
                Invalid Controls: {{getAllErrors(reportForm)  | json}}
                {{reportForm.errors | json}}
                <br/>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </ng-template>
</ngb-panel>
</ngb-accordion> -->
  <!--    <div id="accordion" role="tablist">-->
  <!--      <div class="card-collapse">-->
  <!--        <div class="card-header" role="tab" id="headingOne">-->
  <!--          <h5 class="mb-0">-->
  <!--            <a data-toggle="collapse" href="#collapseOne" aria-expanded="true"-->
  <!--               aria-controls="collapseOne" class="collapsed">-->
  <!--              Form Information-->
  <!--              <i class="material-icons">keyboard_arrow_down</i>-->
  <!--            </a>-->
  <!--          </h5>-->
  <!--        </div>-->
  <!--        <div id="collapseOne" class="collapse" role="tabpanel"-->
  <!--             aria-labelledby="headingOne" data-parent="#accordion" style="">-->
  <!--          <div class="card-body">-->
  <!--            <div class="alert-primary">-->
  <!--              <table class="table-bordered">-->
  <!--                <tr>-->
  <!--                  <th>Description</th>-->
  <!--                  <th>Value</th>-->
  <!--                </tr>-->
  <!--                <tr>-->
  <!--                  <td>Response</td>-->
  <!--                  <td>-->
  <!--                    &lt;!&ndash;                    <div class="text_bold text-dark">{{ createResponse | json }}</div>&ndash;&gt;-->
  <!--                  </td>-->
  <!--                </tr>-->
  <!--                <tr>-->
  <!--                  <td>Form Values</td>-->
  <!--                  <td>-->
  <!--                    <div class="text_bold text-dark">{{ reportForm.value | json }}</div>-->
  <!--                  </td>-->
  <!--                </tr>-->
  <!--                <tr>-->
  <!--                  <td>Form State</td>-->
  <!--                  <td>-->
  <!--                    <div class="text_bold text-dark">-->
  <!--                      Form Touched: {{ reportForm.touched | json }}-->
  <!--                      <br/>-->
  <!--                      Form Valid: {{ reportForm.valid | json }}-->
  <!--                      <br/>-->
  <!--                      SaveBtn State: {{_saveBtnstate}}-->
  <!--                      <br/>-->
  <!--                      Invalid Controls: {{getAllErrors(reportForm)  | json}}-->
  <!--                      {{reportForm.errors | json}}-->
  <!--                      <br/>-->
  <!--                    </div>-->
  <!--                  </td>-->
  <!--                </tr>-->
  <!--              </table>-->
  <!--            </div>-->
  <!--          </div>-->
  <!--        </div>-->
  <!--      </div>-->
  <!--    </div>-->
  <mat-accordion class="example-headers-align">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <!--                <mat-panel-title>-->
        <!--                    Help-->
        <!--                </mat-panel-title>-->
        <mat-panel-description>
          SQL Help
          <mat-icon>help_center</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>
      @for (item of REPORT_HELP; track item) {
      <div>
        <div>
          <label>{{ item.label }}</label>
          <div>{{ item.description }}</div>
          <div class="prettyprint" [innerHTML]="item.code"></div>
        </div>
        <mat-divider></mat-divider>
      </div>
      }
    </mat-expansion-panel>
  </mat-accordion>
</div>
